module.exports = __webpack_public_path__ + "static/media/Sound3.3c54d6c1.mp3";